import { Heading } from '@tiptap/extension-heading';

/**
 * 自定义标题扩展
 * 扩展了基础标题组件，添加了ID属性支持
 */
export const CustomHeading = Heading.extend({
    addAttributes() {
        return {
            // 标题级别属性
            level: {
                default: 1,
                rendered: false,
            },
            // 标题ID属性，用于定位和跳转
            id: {
                default: null,
                parseHTML: (element) => element.getAttribute('id'),
                renderHTML: (attributes) => {
                    if (!attributes.id) return {};
                    return { id: attributes.id };
                },
            },
        };
    },
});
